import {
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  IsUUID,
  ValidateNested,
  IsDateString,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'
import { TeachingDto } from '../../teachings/response/teaching.dto'
export class LessonTeachingResponseDto {
  @ApiProperty({ type: 'string', description: 'ID de l\'association lesson-teaching' })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ type: 'string', description: 'ID de la leçon' })
  @IsNotEmpty()
  @IsUUID('4')
  lessonId!: string

  @ApiProperty({ type: 'string', description: 'ID du chapitre' })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string

  @ApiProperty({ type: 'string', description: "ID de l'enseignement", format: 'uuid' })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId!: string

  @ApiProperty({ description: 'Enseignement associé', type: () => TeachingDto })
  @IsNotEmpty()
  @ValidateNested()
  @Type(() => TeachingDto)
  teaching!: TeachingDto

  @ApiProperty({ type: Boolean, description: 'Visibilité de la leçon' })
  @IsNotEmpty()
  @IsBoolean()
  isVisible!: boolean

  @ApiPropertyOptional({ type: 'string', description: 'ID du statut' })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiProperty({ type: 'string', format: 'date-time', description: 'Date de création' })
  @IsNotEmpty()
  @IsDateString()
  createdAt!: Date | string

  @ApiProperty({ type: 'string', format: 'date-time', description: 'Date de mise à jour' })
  @IsNotEmpty()
  @IsDateString()
  updatedAt!: Date | string
}
